<template>
  <Navbar>
    <template v-slot:navbarTitle>顧客管理</template>
  </Navbar>

  <main id="main" class="container-fluid pt-3">
    <div class="clearfix mb-3">
      <div class="float-end d-print-none">
        <button
          type="button"
          v-on:click.prevent="removeData()"
          class="btn btn-outline-danger me-1"
        >
          <span class="d-block d-sm-none"><i class="bi bi-x"></i></span>
          <span class="d-none d-sm-block"
            ><i class="bi bi-x me-1"></i>削除する</span
          >
        </button>
        <button
          type="button"
          v-on:click.prevent="showClientForm()"
          class="btn btn-outline-success me-1"
        >
          <span class="d-block d-sm-none"><i class="bi bi-pencil"></i></span>
          <span class="d-none d-sm-block"
            ><i class="bi bi-pencil me-1"></i>編集する</span
          >
        </button>
        <router-link
          :to="{
            name: 'ClientList',
          }"
          class="btn btn-outline-dark"
        >
          <span class="d-block d-sm-none"
            ><i class="bi bi-arrow-left"></i
          ></span>
          <span class="d-none d-sm-block">一覧に戻る</span>
        </router-link>
      </div>
      <h5><i class="bi bi-building me-1"></i>顧客詳細</h5>
    </div>

    <div v-if="!is_loading">
      <h5>
        顧客情報
        <a
          class="fs-6"
          data-bs-toggle="collapse"
          href="#resultData"
          role="button"
          aria-expanded="true"
          aria-controls="resultData"
          ><i class="bi bi-arrows-collapse"></i>
        </a>
      </h5>

      <div class="collapse show" id="resultData">
        <div class="row row-cols-1 row-cols-md-2 g-1 g-lg-2">
          <div class="col">
            <table class="table table-bordered table-row bg-white mb-3">
              <tbody>
                <tr>
                  <th class="col-sm-4 bg-light">顧客コード</th>
                  <td class="col-sm-8">{{ client.code }}</td>
                </tr>
                <tr>
                  <th class="bg-light">顧客名</th>
                  <td>{{ client.name }}</td>
                </tr>
                <tr>
                  <th class="bg-light">顧客名（ふりがな）</th>
                  <td>{{ client.kana }}</td>
                </tr>
                <tr>
                  <th class="bg-light">郵便番号</th>
                  <td>{{ client.postal_code }}</td>
                </tr>
                <tr>
                  <th class="bg-light">住所</th>
                  <td>{{ client.address }}</td>
                </tr>
                <tr>
                  <th class="bg-light">電話番号</th>
                  <td>{{ client.phone_number }}</td>
                </tr>
                <tr>
                  <th class="bg-light">メールアドレス</th>
                  <td>{{ client.email }}</td>
                </tr>
                <tr>
                  <th class="bg-light">メモ</th>
                  <td>{{ client.memo }}</td>
                </tr>
                <tr>
                  <th class="bg-light">登録日時</th>
                  <td>{{ client.created_at }}</td>
                </tr>
                <tr>
                  <th class="bg-light">更新日時</th>
                  <td>{{ client.updated_at }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <DeleteDialog ref="confirmDataDelete" @confirm-true="confirmDataDelete" />
    <ClientForm ref="clientForm" @after-submit="afterSubmit">
      <template v-slot:modalTitle>顧客情報編集</template>
    </ClientForm>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Navbar from '@/components/Navbar.vue'
import DeleteDialog from '@/components/AppDeleteDialog.vue'
import ClientForm from '@/components/manage/ClientForm.vue'

export default {
  name: 'ClientDetail',
  components: {
    Navbar,
    DeleteDialog,
    ClientForm,
  },

  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      is_loading: true,
    }
  },
  computed: {
    ...mapGetters({
      client: 'client/detail',
    }),
  },

  async created() {
    try {
      await this.getData(this.id)
    } catch (error) {
      if (error.status) {
        window.setTimeout(() => {
          this.$router.push({
            name: 'ClientList',
          })
        }, this.$store.getters['alert/timeout'])
      }
    } finally {
      this.is_loading = false
    }
  },

  methods: {
    ...mapActions({
      getData: 'client/fetchData',
      deleteData: 'client/deleteData',
    }),
    showClientForm() {
      this.$refs.clientForm.show(this.client)
    },
    afterSubmit() {
      this.getData(this.id)
    },
    removeData() {
      this.$refs.confirmDataDelete.showDialog(
        '顧客データ',
        this.client.name,
        ['単価'],
        ['受注']
      )
    },
    async confirmDataDelete() {
      try {
        await this.deleteData(this.id)
        await this.$router.push({
          name: 'ClientList',
        })
      } catch (e) {
        if (e.response.status == 400) {
          this.$store.dispatch('alert/setErrorMessage', {
            message: e.response.data,
          })
        }
      }
    },
  },
}
</script>
